
import AppSubscriptions from "@/components/account/Subscription.vue";

import Vue from "vue";
export default Vue.extend({
	components: {
		AppSubscriptions,
	},
	i18nEx: {
		componentPrefix: "components.account"
	}
});
